import { render, staticRenderFns } from "./EmailConversationModal.vue?vue&type=template&id=56d1c818"
import script from "./EmailConversationModal.vue?vue&type=script&lang=js"
export * from "./EmailConversationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports